var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowDynamics = function SvgArrowDynamics(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 49 50",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.0783 29.0611L1.63818 26.621C0.60498 25.5878 0.60498 23.9171 1.63818 22.8949L22.9947 1.52735C24.0279 0.49415 25.6986 0.49415 26.7209 1.52735L48.0884 22.8949C49.1216 23.9281 49.1216 25.5988 48.0884 26.621L45.6483 29.0611C44.6041 30.1053 42.9004 30.0833 41.8782 29.0172L29.2599 15.7724L29.2599 47.362C29.2599 48.8239 28.0838 50 26.6219 50L23.1046 50C21.6428 50 20.4667 48.8239 20.4667 47.362L20.4667 15.7724L7.8484 29.0172C6.82618 30.0943 5.1225 30.1163 4.0783 29.0611Z"
  })));
};
export default SvgArrowDynamics;